import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { YambaRootState } from '../store';

interface ClassroomSessionState {
  inSession: boolean,
  highlightsAddedToSession: string[],
  active: boolean
}

const initialState: ClassroomSessionState = {
  inSession: false,
  highlightsAddedToSession: [],
  active: false
};

const classroomSessionSlice = createSlice({
  name: 'classroomSession',
  initialState,
  reducers: {
    startClassroomSession(state) {
      // eslint-disable-next-line no-param-reassign
      state.inSession = true;
    },
    endClassroomSession() {
      return initialState;
    },
    setClassroomActive(state, action: PayloadAction<{ active: boolean }>) {
      // eslint-disable-next-line no-param-reassign
      state.active = action.payload.active;
    },
    addHighlightToCurrentDiscussion(
      state,
      action: PayloadAction<{ comment: string, annotationText: string, timestamp: string, userType: string }>
    ) {
      const {
        comment,
        annotationText,
        timestamp,
        userType
      } = action.payload;
      const iframe = document.querySelector('#yamba_classroom') as HTMLIFrameElement;
      const targetWindow = userType === 'tutor' ? window.parent : iframe.contentWindow;

      targetWindow.postMessage({
        type: 'yamba:addHighlight',
        comment,
        annotationText,
        timestamp
      }, '*');

      state.highlightsAddedToSession.push(timestamp);
    }
  }
});

export const getPreviouslyAdded = (timestamp: string) => (state: YambaRootState) => state.
  classroomSession.highlightsAddedToSession.includes(timestamp);

export const {
  startClassroomSession,
  endClassroomSession,
  setClassroomActive,
  addHighlightToCurrentDiscussion
} = classroomSessionSlice.actions;
export default classroomSessionSlice.reducer;
